import { Text } from '@chakra-ui/react';
import PillButton from '@/components/common/pill-button';
import { Grid as GridIcon, List as ListIcon } from 'react-feather';
import { LocalStorageKeys } from '@/util/local-storage';
import useLocalStorage from 'use-local-storage';
import { exposedMixpanel as mixpanel } from '@/modules/analytics';
import { AnalyticsEvent } from '@/constants/analytics';

const ViewSelector = () => {
  //default value to persist on different sessions
  const [isListView, setIsListView] = useLocalStorage<boolean>(
    LocalStorageKeys.MARKETPLACE_LIST_VIEW_SELECTED,
    localStorage.getItem(LocalStorageKeys.MARKETPLACE_LIST_VIEW_SELECTED) === 'true',
  );

  const toggleView = () => {
    const newValue = !isListView;
    try {
      mixpanel.track(AnalyticsEvent.IS_MARKETPLACE_LIST_VIEW_SELECTED, {
        isListView: newValue,
      });
      mixpanel.register({
        [LocalStorageKeys.MARKETPLACE_LIST_VIEW_SELECTED]: newValue,
      });
    } catch {}
    setIsListView(newValue);
  };
  return (
    <PillButton borderRadius={'md'} onClick={toggleView}>
      {isListView ? (
        <>
          <GridIcon size={16} radius={'md'} />{' '}
          <Text fontSize={'sm'} fontWeight={'semibold'}>
            Grid
          </Text>
        </>
      ) : (
        <>
          {' '}
          <ListIcon size={16} radius={'md'} />
          <Text fontSize={'sm'} fontWeight={'semibold'}>
            List
          </Text>
        </>
      )}
    </PillButton>
  );
};

export default ViewSelector;
